import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'sbc-alphabet-filter',
  template: `
    <ul class="alphabet-list">
      <li class="alphabet-item" *ngFor="let c of charsWithAvailability"
        [class.available]="c.available"
        [class.active]="activeChar === c.char"
        (mousedown)="onLetterChange(c.char)"
        >
          {{ c.char }}
        </li>
    </ul>
  `,
  styles: [`
    .alphabet-list {
      position: relative;
      display: inline-flex;
      justify-content: space-between;
      align-items: center;
      list-style: none;
      margin-top: 28px;
      z-index: 10;
      flex-wrap: wrap;
      justify-content: center;
      padding: 10px;
    }
    .alphabet-list .alphabet-item {
      font-size: 16px;
      background-color: #e5e5e5;
      width: 26px;
      height: 35px;
      margin: 2px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
    .alphabet-list .alphabet-item.available {
      background-color: var(--primary);
      color: white;
    }
    .alphabet-list .alphabet-item:not(.available) {
      pointer-events: none;
    }
    .alphabet-list .alphabet-item.available.active,
    .alphabet-list .alphabet-item.available:hover,
    .alphabet-list .alphabet-item.available.active:hover {
      box-shadow: 0 0 5px var(--primary);
    }
  `],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => AlphabetFilterComponent), multi: true },
  ]
})
export class AlphabetFilterComponent implements ControlValueAccessor {
  @Input()
  set exhibitors(exhibitors: ExhibitorEntry[]) {
    this.charsWithAvailability = this.chars.map((char, idx) => {
      let available = exhibitors.some(exh => idx === 0 ?
        !isNaN(parseInt(exh.name[0]))
        :
        exh.name[0].toUpperCase() === char
      );
      return {
        char,
        available,
      };
    });
    if (this.activeChar && !this.charsWithAvailability.find(cwa => cwa.char === this.activeChar)?.available) {
      const firstAvailableCharacter = this.charsWithAvailability.find(cwa => cwa.available)?.char!;
      this.onLetterChange(firstAvailableCharacter);
    }
  };

  chars: string[] = ['1', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
  charsWithAvailability!: {
    char: string,
    available: boolean
  }[];
  activeChar = '';
  onChange: Function = () => {};

  writeValue(char: string): void {
    this.activeChar = char;
  }

  onLetterChange(char: string) {
    if (char === this.activeChar) {
      char = '';
    }
    this.writeValue(char);
    this.onChange(this.activeChar);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {}
}
